module.exports = __webpack_public_path__ + "e5d62cfdfb6d1a5cc62132b81f04f3c3.png";